import React, { useEffect } from "react";

const SHORTCUTS = [
  { keys: "Ctrl+Z", action: "Undo grid edit" },
  { keys: "Ctrl+Y / Ctrl+Shift+Z", action: "Redo" },
  { keys: "Shift+Click", action: "Select row range" },
  { keys: "?", action: "Show this panel" },
  { keys: "Esc", action: "Close panels" },
];

export default function RfpShortcutsModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/40 p-4" role="dialog" aria-modal>
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-xl dark:border-slate-700 dark:bg-slate-900">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold">Keyboard shortcuts</h3>
          <button type="button" className="text-slate-500 hover:text-slate-800 dark:hover:text-slate-200" onClick={onClose}>
            ✕
          </button>
        </div>
        <dl className="space-y-3">
          {SHORTCUTS.map((s) => (
            <div key={s.keys} className="flex justify-between gap-4 text-sm">
              <dt className="font-mono text-emerald-700 dark:text-emerald-300">{s.keys}</dt>
              <dd className="text-slate-600 dark:text-slate-300">{s.action}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
